import AppService from 'App/legacy/AppService';
import type { ListViewFilter } from 'App/resources/AllIWant';

type Filters = Record<string, ListViewFilter>;

const PREFIX = 'ui:list-filters:';

const storageKey = (listType: string) =>
	`${PREFIX}${listType}:${AppService.getCustomerId()}-${AppService.getSelf()?.id}`;

export const rememberListFilters = (listType: string, filters: Filters) => {
	try {
		sessionStorage.setItem(storageKey(listType), JSON.stringify(filters));
	} catch (error) {
		console.warn('Could not remember the list filters', error);
	}
};

export const recallListFilters = (listType: string): Filters | null => {
	try {
		const stored = sessionStorage.getItem(storageKey(listType));
		return stored ? (JSON.parse(stored) as Filters) : null;
	} catch (error) {
		console.warn('Could not read the remembered list filters', error);
		return null;
	}
};
